import styled from 'styled-components';
import Stack from 'atoms/Layout/Stack/Stack';
import { cssVar } from 'styles/helper';

interface SideNavContainerProps {
  isOpen: boolean;
}

export const SideNavContainer = styled(Stack)<SideNavContainerProps>`
  top: 0;
  right: 0;
  z-index: -1;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  box-shadow: ${cssVar('shadow-lg')};
  transform: ${({ isOpen }) => (isOpen ? 'translateX(0)' : 'translateX(110%)')};
  transition: transform 0.35s ease-in-out;
  padding-top: var(--header-height, 80px);

  a,
  button {
    box-sizing: border-box;
  }

  .side-nav-cta {
    border-top: 1px solid ${cssVar('border-secondary')};
  }
`;
